class LgBundleBuilder extends HTMLElement {
  selectionUpdateUnsubscriber = null

  constructor() {
    super();

    this.querySelectorAll('.js-bundle-size').forEach(input => input.addEventListener('change', this.handleBundleSizeChange.bind(this)))
    this.addToCartButton = this.querySelector('[data-add-to-cart]')
    this.placeholderButton = this.querySelector('.add-to-cart-placeholder')
    this.form = this.querySelector('form')
  }

  connectedCallback () {
    this.selectionUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.selectionUpdate, this.handleSelections.bind(this));

    this.addToCartButton.addEventListener('click', this.handleSubmit.bind(this))

    this.querySelector('.js-purchase-option[value="onetime"]').click()
    this.querySelector('.rc_block__type__onetime').classList.add('rc_block__type--active')
    this.querySelector('.rc_block__type__autodeliver').classList.remove('rc_block__type--active')
  }

  disconnectedCallback () {
    if (this.selectionUpdateUnsubscriber) {
      this.selectionUpdateUnsubscriber();
    }
  }

  handleBundleSizeChange (event) {
    this.querySelectorAll('.js-variant-title').forEach(el => el.innerHTML = event.target.dataset.title)
    window.bundles.size = parseInt(event.target.value)

    publish(PUB_SUB_EVENTS.selectionUpdate)
  }

  handleSelections () {
    setTimeout(() => {
      const mainVariant = window.bundles.main_item.variants.find(variant => variant.size === window.bundles.size)

      this.querySelectorAll('.js-onetime-price').forEach((el) => {
        el.classList[mainVariant.price > 0 ? 'remove' : 'add']('hide')
        el.innerHTML = theme.Currency.formatMoney(mainVariant.price, theme.settings.moneyFormat)
      })

      this.querySelectorAll('.js-autodeliver-price').forEach((el) => {
        el.classList[mainVariant.price > 0 ? 'remove' : 'add']('hide')
        el.innerHTML = theme.Currency.formatMoney(mainVariant.price * 0.85, theme.settings.moneyFormat)
      })

      const totalQuantity = window.bundles.selections.map(selection => selection.quantity)
        .reduce((a, b) => a + b, 0)

      if (totalQuantity * 12 === window.bundles.size) {
        this.addToCartButton.removeAttribute('disabled')
        this.addToCartButton.classList.remove('hide')
        this.placeholderButton.classList.add('hide')
      } else {
        this.addToCartButton.setAttribute('disabled', true)

        this.placeholderButton.classList[totalQuantity * 12 > window.bundles.size ? 'add': 'remove']('hide')
        this.addToCartButton.classList[totalQuantity * 12 > window.bundles.size ? 'remove': 'add']('hide')

        this.placeholderButton.innerHTML = `${(window.bundles.size / 12 - totalQuantity)} more needed to Add to Cart`
      }
    }, 100)
  }

  handleSubmit () {
    const sellingPlan = this.form.querySelector('[name="selling_plan"]')?.value
    const bundle_id = crypto.randomUUID()
    const items = window.bundles.selections.map(selection => {
      const item = window.bundles.items.find(e => e.id === selection.id)
      return Object.assign({
        id: item.current_variant.id,
        quantity: selection.quantity,
        properties: {
          _bundle: "small-bundle",
          _bundle_id: bundle_id,
          _bundle_size: `${window.bundles.size} Cans`,
          _bundle_handle: window.bundles.main_item.handle
        }
      }, !!sellingPlan ? {
        selling_plan: sellingPlan
      }: {})
    })

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: JSON.stringify({ items }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((data) => {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
        }
      }));
    })
  }
}

customElements.define('lg-bundle-builder', LgBundleBuilder)

class LgBundleItem extends HTMLElement {
  selectionUpdateUnsubscriber = undefined;

  constructor() {
    super();
    this.id = parseInt(this.getAttribute('id'))
    this.variantId = parseInt(this.getAttribute('variant-id'))
    this.quantity = 0

    this.addButton = this.querySelector('.js-add')
    this.quantitySelector = this.querySelector('.js-qty__wrapper')
    this.increaseButton = this.querySelector('.js-qty__adjust--plus')
    this.decreaseButton = this.querySelector('.js-qty__adjust--minus')
    this.quantityInput = this.querySelector('.js-qty__num')
  }

  connectedCallback () {
    this.addButton.addEventListener('click', this.increase.bind(this))
    this.increaseButton.addEventListener('click', this.increase.bind(this))
    this.decreaseButton.addEventListener('click', this.decrease.bind(this))

    this.selectionUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.selectionUpdate, this.validateSelection.bind(this));
  }

  disconnectedCallback () {
    this.addButton.removeEventListener('click', this.increase.bind(this))
    this.increaseButton.removeEventListener('click', this.increase.bind(this))
    this.decreaseButton.removeEventListener('click', this.decrease.bind(this))

    if (this.selectionUpdateUnsubscriber) {
      this.selectionUpdateUnsubscriber();
    }
  }

  increase () {
    const totalQuantity = window.bundles.selections.map(selection => selection.quantity).reduce((a, b) => a + b, 0)
    if (totalQuantity * 12 >= window.bundles.size) return;

    this.quantity += 1
    this.quantityInput.value = this.quantity

    this.updateSelection()
    publish(PUB_SUB_EVENTS.selectionUpdate)
  }

  decrease () {
    this.quantity = Math.max(this.quantity - 1, 0)
    this.quantityInput.value = this.quantity

    this.updateSelection()

    publish(PUB_SUB_EVENTS.selectionUpdate)
  }

  updateSelection () {
    const selections = window.bundles.selections.filter(bundle => +bundle.id !== +this.id)
    window.bundles.selections = [
      ...selections,
      {
        id: +this.id,
        quantity: this.quantity,
      }
    ].filter(selection => selection.quantity > 0)

    this.addButton.classList[this.quantity > 0 ? 'add' : 'remove']('hide')
    this.quantitySelector.classList[this.quantity > 0 ? 'remove' : 'add']('hide')
  }

  validateSelection () {
    let itemsInBundle = 0
    let selections = []
    window.bundles.selections.map(selection => {
      return (Array(selection.quantity).fill(0)).map(i => {
        itemsInBundle += 12

        if (itemsInBundle <= window.bundles.size) {
          const index = selections.findIndex(e => e.id === selection.id)
          if (index > -1) {
            selections[index].quantity += 1
          } else {
            selections = [...selections, {
              id: selection.id,
              quantity: 1
            }]
          }
        }
      })
    })

    window.bundles.selections = selections
    const selection = window.bundles.selections.find(item => item.id === +this.id)

    this.quantity = selection?.quantity || 0
    this.quantityInput.value = this.quantity

    this.updateSelection()

    const totalQuantity = window.bundles.selections.map(selection => selection.quantity).reduce((a, b) => a + b, 0)
    this.addButton.disabled = (totalQuantity * 12 >= window.bundles.size);
  }
}

customElements.define('lg-bundle-item', LgBundleItem)

class LgBundleSelections extends HTMLElement {
  selectionUpdateUnsubscriber = undefined;

  constructor() {
    super();

    this.selectionContainer = this.querySelector('.js-bundle-selections')
  }

  connectedCallback () {
    this.selectionUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.selectionUpdate, this.updateSelection.bind(this));
  }

  disconnectedCallback () {
    if (this.selectionUpdateUnsubscriber) {
      this.selectionUpdateUnsubscriber();
    }
  }

  handleRemove (e) {
    const btn = e.target.closest('.js-selection-remove')
    const id = parseInt(btn.dataset.id)

    const selectionIndex = window.bundles.selections.findIndex(item => item.id === id)
    const selection = window.bundles.selections[selectionIndex]

    if (selection.quantity > 1) {
      window.bundles.selections[selectionIndex].quantity = selection.quantity - 1
    } else {
      window.bundles.selections = window.bundles.selections.filter(item => item.id !== id)
    }

    publish(PUB_SUB_EVENTS.selectionUpdate)
  }

  updateSelection () {
    const remainingQty = (window.bundles.size / 12) - window.bundles.selections.map(selection => selection.quantity).reduce((a, b) => a + b, 0)
    let itemsInBundle = 0
    const selectionsHtml = window.bundles.selections.map(selection => {
      const item = window.bundles.items.find(e => e.id === selection.id)
      return (Array(selection.quantity).fill(0)).map(i => {
        itemsInBundle += 12

        if (itemsInBundle <= window.bundles.size) {
          return `<li class="lg-bundle-selection">
            <button
              type="button"
              class="js-selection-remove lg-bundle-selection-remove"
              data-id="${selection.id}"
            >
              <svg width="16px" height="16px" viewBox="0 0 0.48 0.48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.106 0.106a0.02 0.02 0 0 1 0.028 0L0.24 0.212 0.346 0.106a0.02 0.02 0 1 1 0.028 0.028L0.268 0.24l0.106 0.106a0.02 0.02 0 0 1 -0.028 0.028L0.24 0.268 0.134 0.374A0.02 0.02 0 0 1 0.106 0.346L0.212 0.24 0.106 0.134a0.02 0.02 0 0 1 0 -0.028" fill="#001689"/></svg>
            </button>
            <img src="${item.featured_image}" alt="${item.title}"/>
          </li>`
        } else {
          return ''
        }
      }).join('')
    }).join('')

    const emptyBoxSnippets = (Array(Math.max(remainingQty, 0)).fill(0)).map(i => {
      return `<li class="lg-bundle-selection">
        <img src="${window.bundles.placeholder_url}"/>
      </li>`
    }).join('')

    this.selectionContainer.innerHTML = selectionsHtml + emptyBoxSnippets

    this.querySelectorAll('.js-selection-remove').forEach(btn => btn.addEventListener('click', this.handleRemove.bind(this)))
  }
}

customElements.define('lg-bundle-selections', LgBundleSelections)
